/* -- Angular Dependencies -- */
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
/* -- 3rd party Dependencies -- */
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
/* -- Singleton Services -- */
import {AuthenticationService} from './services/authentication.service';
import {UserService} from './data-services/user.service';
import {TemplateModalService} from './services/template-modal.service';
import {FileUploadService} from './services/fileUpload.service';
import {EventsHubService} from './events-hub.service';
import {AuthGuard} from './guards/auth.guard';
import {LoggedGuard} from './guards/logged.guard';
import {AuthInterceptor} from './auth-interceptor';
import {AuthorizationService} from './services/authorization.service';
import {throwIfAlreadyLoaded} from './module-import-guard';
/* -- App Components -- */
import {SpinnerComponent} from '../shared/components/spinner/spinner.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {BannerNotificationsComponent} from '../shared/components/banner-notifications/banner-notifications.component';
import {JqueryCommonService} from '../shared/services/jquery-common.service';
import {HammerCommonServices} from '../shared/services/hammerCommon.services';
import {GlobalIntegrationService} from '../shared/services/globalIntegration.service';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {BannerNotificationsService, LocalStorageService, SanitizeService, SpinnerService, UtilsService} from '../xform-compat';


@NgModule({
    imports: [
        CommonModule, FormsModule, RouterModule, TranslateModule, NgbModule,
        SweetAlert2Module.forRoot({
            provideSwal: () => import('sweetalert2').then(({default: swal}) => swal.mixin({
                buttonsStyling: false,
                customClass: { confirmButton: 'btn btn-danger me-3', cancelButton: 'btn btn-cancel me-3' },
                reverseButtons: true,
                showCancelButton: true
            }))
        })
    ],
    exports: [
        CommonModule, FormsModule, RouterModule, TranslateModule, NgbModule, SweetAlert2Module,
        PageNotFoundComponent, SpinnerComponent, BannerNotificationsComponent
    ],
    declarations: [PageNotFoundComponent, SpinnerComponent, BannerNotificationsComponent],
    providers: [
        AuthenticationService, UserService, AuthGuard, EventsHubService, LoggedGuard,
        TemplateModalService, FileUploadService,
        LocalStorageService, TranslateService, SpinnerService, BannerNotificationsService, SanitizeService, UtilsService,
        AuthorizationService, JqueryCommonService, GlobalIntegrationService, HammerCommonServices,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
